<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="centralStation()"
  [imageUrl]="(imageUrl$ | async) || fallbackImageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [monitoringCategory]="MonitoringCategory.CENTRAL_STATIONS"
      [monitoringItems]="monitoringItems"
      [monitoringTitle]="monitoringTitle"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="centralStation()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-custom-part-numbers [floorplanItem]="centralStation()"></app-floorplan-custom-part-numbers>
    </div>
  }
</app-floorplan-item-details>
